import './BasicAddressInput.scss';

import type { AddressSearchProvider } from 'api/models/mainservice';
import { inputNameWithPrefx } from 'components/forms/_common';
import { useAddressFormOperations } from 'helpers/addressHelpers';
import { useCustomTranslation } from 'helpers/translationHelper';
import { useValidators } from 'helpers/validation';
import React from 'react';

import TextInput from '../TextInput';
import AddressAutoCompleteInput from './AddressAutoCompleteInput';

interface BasicAddressInputProps {
  defaultSearchProvider: AddressSearchProvider;
  prefix?: string;
  required?: boolean;
  isPublic?: boolean;
}

const BasicAddressInput = ({
  prefix,
  required,
  defaultSearchProvider,
  isPublic
}: BasicAddressInputProps) => {
  const { loadAddresses, handleSelect, isSearchingAddressAutoCompleteItems, itemsForAutocomplete } =
    useAddressFormOperations(prefix);

  const validators = useValidators();
  const { tInput } = useCustomTranslation();

  return (
    <div className="BasicAddressInput">
      <AddressAutoCompleteInput
        name={inputNameWithPrefx('street', prefix)}
        required={required}
        options={{
          required: required ? validators.required : undefined,
          maxLength: validators.maxLength(100)
        }}
        items={itemsForAutocomplete}
        label={tInput('address_street_input')}
        placeholder={tInput('address_street_placeholder')}
        handleSelect={(id, provider) => handleSelect(id, provider, isPublic)}
        loadAddresses={(phrase, provider) => loadAddresses(phrase, provider, isPublic)}
        defaultSearchProvider={defaultSearchProvider}
        isSearching={isSearchingAddressAutoCompleteItems}
      />
      <TextInput
        name={inputNameWithPrefx('city', prefix)}
        label={tInput('address_city_input')}
        placeholder={tInput('address_city_placeholder')}
        required={required}
        options={{
          required: required ? validators.required : undefined,
          maxLength: validators.maxLength(50)
        }}
      />
      <TextInput
        name={inputNameWithPrefx('postalCode', prefix)}
        label={tInput('address_postal_code_input')}
        placeholder={tInput('address_postal_code_placeholder')}
        required={required}
        options={{
          required: required ? validators.required : undefined,
          maxLength: validators.maxLength(10)
        }}
      />
      <TextInput
        name={inputNameWithPrefx('country', prefix)}
        label={tInput('address_country_input')}
        placeholder={tInput('address_country_placeholder')}
        required={required}
        options={{
          required: required ? validators.required : undefined
        }}
      />
    </div>
  );
};

export default BasicAddressInput;
